import { combineReducers } from 'redux'
import * as quiz from './quiz'
import * as user from './user'

export default combineReducers(Object.assign(
	user,
	quiz
))